import { defineMessages } from "react-intl";

export const messages = defineMessages({
  channelName: {
    defaultMessage: "Channel name",
    id: "nKwgxY",
    description: "select label",
  },
  selectChannel: {
    id: "G/pgG3",
    defaultMessage: "Select a channel",
    description: "dialog header",
  },
});
